﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Paises } from "../Paises";

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.PK, prompt: 'País' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Provincia Id' }),
        vc_provincia_nombre: new EntityColumn<string>({ name: 'vc_provincia_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Provincia' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        prov_brwStandard: { name: 'prov_brwStandard', keyMappings: { c_provincia_id: 0 } }
    }
)


const lookups = () =>
(
    {
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        }
    }
)

export class ProvinciasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();


    constructor() {
        super('Provincias');
    }
}